import { render } from "./ProjectSectionStoryAvailableLanguages.vue?vue&type=template&id=0203ac7b"
import script from "./ProjectSectionStoryAvailableLanguages.vue?vue&type=script&lang=js"
export * from "./ProjectSectionStoryAvailableLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__